import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { DetailedAgentStatComponent } from './detailed-agent-stat.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild()
  ],
  declarations: [
    DetailedAgentStatComponent
  ],
  exports: [
    DetailedAgentStatComponent
  ]
})
export class DetailedAgentStatModule {}
